import { Suspense, type FunctionComponent } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyBoardPowerUpsDirectory: FunctionComponent = () => {
  const BoardPowerUpsDirectory = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "board-power-ups-directory" */ './BoardPowerUpsDirectory'
      ),
    { namedImport: 'BoardPowerUpsDirectory' },
  );

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-web-eng',
        feature: 'Board Power Ups',
      }}
    >
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <BoardPowerUpsDirectory />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
